import loader from '../moduleLoader.js';

class Gallery {
    constructor(gallery) {
        this.gallery = gallery;
        this.slider = undefined;
    }
    init() {

        window.addEventListener('FlktyLastSlide', (e) => {
            this.slider = e.detail;
            const paging = document.querySelector('[data-paging-for=Gallery]');
            paging.click();
        });

        window.addEventListener('ResultUpdated', () => {          
            loader.parseDom(this.gallery);
        });

        window.addEventListener('ResultAppended', (e) => {             
            const newItems = this.gallery.querySelectorAll('.gallery__item--new');  
            let sliderItems = [];
            Array.from(newItems).forEach(element => {  
                loader.parseDom(element);
                if(this.slider) {
                    const html = element.querySelector('[data-module=Lightbox]').dataset.embed;
                    const slide = (new DOMParser().parseFromString(html, 'text/html')).body.firstChild;
                    sliderItems.push(slide);               
                    element.classList.remove('gallery__item--new');
                }
            }); 
            if(this.slider) {
                this.slider.append(sliderItems);
            }                   
        });
    }
}

loader.add('Gallery', Gallery);
export default Gallery;
